import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tab,
  Tabs,
} from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import PackageRepository from "../../../repositories/packageRepository";
import { useGlobal } from "../../../contexts/globalContext";
import * as S from "./styles";

const PackageSummaryCard = ({ buscaAtual }) => {
  const { user, signed } = useGlobal();
  const history = useHistory();
  const [packageData, setPackageData] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [hotelModalOpen, setHotelModalOpen] = useState(false);
  const [selectedRoomIndex, setSelectedRoomIndex] = useState(() => {
    const packageSelected = sessionStorage.getItem("@PackageSelected");
    if (packageSelected) {
      try {
        const parsed = JSON.parse(packageSelected);
        return parsed.roomIndex || 0;
      } catch (e) {
        return 0;
      }
    }
    return 0;
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [shortenCoinAlias, setShortenCoinAlias] = useState("Pts");

  const getValuesByUser = (val) => {
    let value = signed
      ? val * user.catalog.catalogCurrencyConfig.conversionRate
      : val;

    return signed ? Math.ceil(Math.round(value)) : value;
  };

  useEffect(() => {
    setShortenCoinAlias(
      user?.campaign?.campaignConfig?.shortenCoinAlias || "Pts"
    );
  }, [user?.campaign?.campaignConfig?.shortenCoinAlias]);

  useEffect(() => {
    const fetchPackageData = async () => {
      try {
        setLoading(true);
        setError(null);

        const storedRequest = localStorage.getItem("@packageRequest");

        if (!storedRequest) {
          setError(
            "Um erro ocorreu na busca dos pacotes, procure o suporte para mais informações."
          );
          setLoading(false);
          return;
        }

        const request = JSON.parse(storedRequest);
        const packageRepository = new PackageRepository();

        const response = await packageRepository.availablePackages(request);

        if (response.status === 200 && response.data) {
          if (response.data === "No availability" || response.data?.message === "No availability") {
            sessionStorage.removeItem("@PackageSelected");
            sessionStorage.removeItem("@PackageAvailResponse");
            history.push("/busca/resultado-pesquisa");
            return;
          }

          setPackageData(response.data);

          const existingSelection = sessionStorage.getItem("@PackageSelected");
          if (!existingSelection) {
            const mainPackage = response.data.packageAvails?.[0];
            const hotelAvail = mainPackage?.hotelAvails?.[0];
            const roomGroups = hotelAvail?.roomGroups || [];
            const firstRoom = roomGroups[0]?.rooms?.[0];

            if (firstRoom && firstRoom.fares) {
              const totalFare =
                response.data.packageWithoutRoomCashPrice + firstRoom.cashPrice;

              const packageSelection = {
                roomIndex: 0,
                roomName: firstRoom.roomType?.name || firstRoom.boardType?.name,
                totalPrice: totalFare,
                hotelName: hotelAvail?.hotel?.name,
                checkIn: hotelAvail?.checkIn,
                key: firstRoom?.key,
                checkOut: hotelAvail?.checkOut,
                nights: mainPackage?.package?.nights || 3,
              };

              sessionStorage.setItem(
                "@PackageSelected",
                JSON.stringify(packageSelection)
              );
              window.dispatchEvent(new Event("packageSelectionChanged"));
            }
          }

          sessionStorage.setItem(
            "@PackageAvailResponse",
            JSON.stringify(response)
          );
        } else {
          setError(
            "Não achamos pacotes disponíveis no momento, tente novamente mais tarde."
          );
        }
      } catch (err) {
        console.error("Error fetching package data:", err);
        setError(
          "Um erro ocorreu na busca dos pacotes, procure o suporte para mais informações."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchPackageData();
  }, []);

  if (loading) {
    return (
      <S.PackageCard>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="400px"
        >
          <CircularProgress style={{ color: "#FD665E" }} size={60} />
        </Box>
      </S.PackageCard>
    );
  }

  if (error) {
    return (
      <S.PackageCard>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          minHeight="400px"
          padding="40px"
          textAlign="center"
        >
          <span style={{ fontSize: "48px", marginBottom: "16px" }}>⚠️</span>
          <h3 style={{ color: "#FD665E", marginBottom: "8px" }}>
            Erro ao carregar pacote
          </h3>
          <p style={{ color: "#666" }}>{error}</p>
        </Box>
      </S.PackageCard>
    );
  }

  if (!packageData || packageData.length === 0) {
    return null;
  }

  if(!packageData.packageAvails || packageData.packageAvails.length === 0){
    return null;
  }

  const mainPackage = packageData.packageAvails[0];
  const hotelAvails = mainPackage.hotelAvails || [];
  const flightAvails = mainPackage.flightAvails[0] || [];
  const servicePackageAvails = mainPackage.servicePackageAvails || [];
  const packageInfo = mainPackage.package || {};

  const hotel = hotelAvails[0]?.hotel;
  const hotelAvail = hotelAvails[0];
  const roomGroups = hotelAvail?.roomGroups || [];
  const checkIn = hotelAvail?.checkIn;
  const checkOut = hotelAvail?.checkOut;

  const outboundFlights =
    flightAvails.routes.filter((route) => route?.numberRoute === 1) || [];
  const returnFlights =
    flightAvails.routes.filter((route) => route?.numberRoute === 2) || [];

  const allFlights = [...outboundFlights, ...returnFlights];
  const firstFlight = outboundFlights[0].flights[0] || allFlights[0];
  const secondFlight = returnFlights[0].flights[0] || allFlights[1];

  if (!hotel) {
    return null;
  }

  const formatDate = (dateString) => {
    try {
      const date =
        dateString.length > 10
          ? new Date(dateString)
          : new Date(`${dateString}T00:00:00`);
      return format(date, "dd/MM/yyyy", { locale: ptBR });
    } catch (error) {
      return dateString;
    }
  };

  const formatTime = (dateString) => {
    try {
      const date =
        dateString.length > 10
          ? new Date(dateString)
          : new Date(`${dateString}T00:00:00`);
      return format(date, "HH:mm", { locale: ptBR });
    } catch (error) {
      return dateString;
    }
  };

  const calculateDuration = (checkInDate, checkOutDate) => {
    try {
      const startDate = new Date(checkInDate);
      const endDate = new Date(checkOutDate);
      const diffTime = Math.abs(endDate - startDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    } catch (error) {
      return 0;
    }
  };

  const duration =
    packageInfo.days || calculateDuration(checkIn, checkOut) || 4;
  const nights = packageInfo.nights || (duration > 0 ? duration - 1 : 3);
  const destination =
    packageInfo.destination || hotel.address?.city?.name || "Buenos Aires";
  const origin = packageInfo.origin || firstFlight?.origin?.code || "GRU";
  const countryCode = hotel.address?.city?.country?.code || "AR";

  const originAirport = firstFlight?.origin?.code || origin || "GRU";
  const destinationAirport = firstFlight?.destination?.code || "AEP";

  const airline =
    firstFlight?.airline?.name || firstFlight?.validatingcarrier || "LATAM";
  const airlineCode =
    firstFlight?.airline?.code || firstFlight?.validatingcarrier || "LA";

  const packageTitle = `${destination} - ${hotel.address?.city?.name} - ${
    packageInfo.name || "Carnaval"
  } - Bloqueio ${originAirport} - QSD/${String(nights).padStart(2, "0")}N`;

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleOpenHotelModal = () => {
    setHotelModalOpen(true);
  };

  const handleCloseHotelModal = () => {
    setHotelModalOpen(false);
  };

  const handleRoomSelection = (roomIndex) => {
    setSelectedRoomIndex(roomIndex);

    const selectedRoom = roomGroups[0]?.rooms[roomIndex];
    if (selectedRoom && selectedRoom.fares) {
      const packageSelection = {
        roomIndex: roomIndex,
        roomName: selectedRoom.roomType?.name || selectedRoom.boardType?.name,
        totalPrice:
          selectedRoom.cashPrice + packageData.packageWithoutRoomCashPrice,
        hotelName: hotel?.name,
        checkIn: checkIn,
        checkOut: checkOut,
        nights: nights,
      };

      sessionStorage.setItem(
        "@PackageSelected",
        JSON.stringify(packageSelection)
      );
      window.dispatchEvent(new Event("packageSelectionChanged"));
      handleCloseHotelModal();
    }
  };

  const TabPanel = ({ children, value, index }) => (
    <div
      hidden={value !== index}
      style={{ overflow: "auto", maxHeight: "calc(90vh - 200px)" }}
    >
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );

  return (
    <S.PackageCard>
      {packageData && (
        <S.PackageHeader>
          <S.PackageTitle>Detalhe Do Pacote</S.PackageTitle>
          {packageTitle && <S.PackageInfo>{packageTitle}</S.PackageInfo>}
        </S.PackageHeader>
      )}

      {packageData && (
        <S.PackageContent>
          {hotel && (
            <S.HotelTopSection>
              <Grid container spacing={2}>
                {hotel.images && hotel.images.length > 0 && (
                  <Grid item xs={12} sm={4}>
                    <S.HotelImage
                      src={
                        hotel.images[0].medium ||
                        hotel.images[0].large ||
                        hotel.images[0].small
                      }
                      alt={hotel.name}
                    />
                  </Grid>
                )}

                <Grid item xs={12} sm={hotel.images?.length > 0 ? 8 : 12}>
                  <S.HotelInfo>
                    {(destination || hotel.name) && (
                      <S.HotelName>
                        {destination && `${destination} - ${countryCode || ""}`}
                        {packageInfo.name && ` - ${packageInfo.name}`}
                        {origin && ` - Bloqueio ${origin}`}
                        {nights && ` - QSD/${String(nights).padStart(2, "0")}N`}
                      </S.HotelName>
                    )}

                    {(hotel.address?.city?.name || packageInfo.name) && (
                      <S.HotelAddress>
                        {packageInfo.name && `${packageInfo.name} em `}
                        {hotel.address?.city?.name}
                        {origin &&
                          ` saindo de ${
                            origin === "GRU" ? "Guarulhos" : origin
                          }`}
                        {nights &&
                          duration &&
                          ` - ${String(nights).padStart(
                            2,
                            "0"
                          )} dias/${duration} noites`}
                      </S.HotelAddress>
                    )}

                    {(packageInfo.description ||
                      hotel.address?.city?.name ||
                      hotel.highlight) && (
                      <S.HotelDescription>
                        {packageInfo.description ? (
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                packageInfo.description.substring(0, 300) +
                                "...",
                            }}
                          />
                        ) : hotel.highlight ? (
                          hotel.highlight
                        ) : (
                          hotel.address?.city?.name &&
                          `Explore ${hotel.address.city.name} e descubra uma experiência única em uma das cidades mais fascinantes.`
                        )}
                      </S.HotelDescription>
                    )}

                    <S.PackageDetailsLink onClick={handleOpenModal}>
                      Ver detalhes do pacote
                    </S.PackageDetailsLink>
                  </S.HotelInfo>
                </Grid>
              </Grid>
            </S.HotelTopSection>
          )}

          {hotel && (
            <S.HotelSection>
              <S.ThreeSectionContainer>
                {hotel.name && (
                  <S.HotelInfoSection>
                    <S.HotelLogo>
                      <span>{hotel.name.toUpperCase()}</span>
                      {hotel.stars && (
                        <S.StarRating>
                          {[...Array(hotel.stars)].map((_, index) => (
                            <span key={index}>⭐</span>
                          ))}
                        </S.StarRating>
                      )}
                    </S.HotelLogo>

                    {(checkIn || checkOut) && (
                      <S.HotelDetails>
                        {checkIn && checkOut && (
                          <div>
                            {formatDate(checkIn)} Até {formatDate(checkOut)}
                          </div>
                        )}
                        {hotelAvail?.provider && (
                          <div>{hotelAvail.provider}</div>
                        )}
                      </S.HotelDetails>
                    )}

                    <S.PackageDetailsLink onClick={handleOpenHotelModal}>
                      Ver detalhes do hotel
                    </S.PackageDetailsLink>
                  </S.HotelInfoSection>
                )}

                {(firstFlight || secondFlight || flightAvails?.length > 0) && (
                  <S.FlightInfoSection>
                    <S.FlightTable>
                      {firstFlight && (
                        <S.FlightRow>
                          <S.FlightIcon>✈️</S.FlightIcon>
                          <S.FlightDetails>
                            <div>
                              <strong>
                                {firstFlight.origin?.code || originAirport}
                                {airlineCode && ` - ${airlineCode}`}
                              </strong>
                            </div>
                            <div>
                              <strong>
                                {firstFlight.destination?.code ||
                                  destinationAirport}
                                {airlineCode && ` - ${airlineCode}`}
                              </strong>
                            </div>
                          </S.FlightDetails>
                          <S.FlightTimes>
                            <div>
                              {firstFlight.stopsCount === 0
                                ? "Direto"
                                : `${firstFlight.stopsCount} parada(s)`}
                            </div>
                            <div>
                              {formatTime(firstFlight.departure) ||
                                formatTime(firstFlight.departureDate)}
                            </div>
                          </S.FlightTimes>
                          <S.FlightCodes>
                            <div>
                              <strong>
                                {firstFlight.destination?.code ||
                                  destinationAirport}
                              </strong>
                            </div>
                            <div>
                              <strong>
                                {firstFlight.number || firstFlight.flightNumber}
                              </strong>
                            </div>
                          </S.FlightCodes>
                        </S.FlightRow>
                      )}

                      {secondFlight && (
                        <S.FlightRow>
                          <S.FlightIcon>✈️</S.FlightIcon>
                          <S.FlightDetails>
                            <div>
                              <strong>
                                {secondFlight.origin?.code ||
                                  destinationAirport}
                                {airlineCode && ` - ${airlineCode}`}
                              </strong>
                            </div>
                            <div>
                              <strong>
                                {secondFlight.destination?.code ||
                                  originAirport}
                                {airlineCode && ` - ${airlineCode}`}
                              </strong>
                            </div>
                          </S.FlightDetails>
                          <S.FlightTimes>
                            <div>
                              {secondFlight.stopsCount === 0
                                ? "Direto"
                                : `${secondFlight.stopsCount} parada(s)`}
                            </div>
                            <div>
                              {formatTime(secondFlight.departure) ||
                                formatTime(secondFlight.departureDate)}
                            </div>
                          </S.FlightTimes>
                          <S.FlightCodes>
                            <div>
                              <strong>
                                {secondFlight.destination?.code ||
                                  originAirport}
                              </strong>
                            </div>
                            <div>
                              <strong>
                                {secondFlight.number ||
                                  secondFlight.flightNumber}
                              </strong>
                            </div>
                          </S.FlightCodes>
                        </S.FlightRow>
                      )}

                      {!firstFlight &&
                        !secondFlight &&
                        (originAirport || destinationAirport) && (
                          <>
                            <S.FlightRow>
                              <S.FlightIcon>✈️</S.FlightIcon>
                              <S.FlightDetails>
                                <div>
                                  <strong>{originAirport || "Origem"}</strong>
                                </div>
                                <div>
                                  <strong>
                                    {destinationAirport || "Destino"}
                                  </strong>
                                </div>
                              </S.FlightDetails>
                              <S.FlightTimes>
                                <div>Direto</div>
                                <div>{checkIn && formatTime(checkIn)}</div>
                              </S.FlightTimes>
                              <S.FlightCodes>
                                <div>
                                  <strong>
                                    {destinationAirport || "Destino"}
                                  </strong>
                                </div>
                                <div>
                                  <strong>--</strong>
                                </div>
                              </S.FlightCodes>
                            </S.FlightRow>
                            <S.FlightRow>
                              <S.FlightIcon>✈️</S.FlightIcon>
                              <S.FlightDetails>
                                <div>
                                  <strong>
                                    {destinationAirport || "Destino"}
                                  </strong>
                                </div>
                                <div>
                                  <strong>{originAirport || "Origem"}</strong>
                                </div>
                              </S.FlightDetails>
                              <S.FlightTimes>
                                <div>Direto</div>
                                <div>{checkOut && formatTime(checkOut)}</div>
                              </S.FlightTimes>
                              <S.FlightCodes>
                                <div>
                                  <strong>{originAirport || "Origem"}</strong>
                                </div>
                                <div>
                                  <strong>--</strong>
                                </div>
                              </S.FlightCodes>
                            </S.FlightRow>
                          </>
                        )}
                    </S.FlightTable>
                  </S.FlightInfoSection>
                )}

                {(packageInfo.name ||
                  servicePackageAvails?.length > 0 ||
                  destination) && (
                  <S.PackageItemsSection>
                    {(destination || packageInfo.name || originAirport) && (
                      <S.PackageItemsHeader>
                        {destination && `${destination}`}
                        {countryCode && ` - ${countryCode}`}
                        {packageInfo.name && ` - ${packageInfo.name}`}
                        {originAirport && ` - Bloqueio ${originAirport}`}
                        {(packageInfo.start || checkIn) &&
                          ` - ${formatDate(packageInfo.start || checkIn)}`}
                      </S.PackageItemsHeader>
                    )}

                    <S.PackageItemsList>
                      {(originAirport || hotel.name) && (
                        <div>
                          ✓ Traslado Aeroporto {originAirport || "Origem"} /{" "}
                          {hotel.name || "Hotel"}
                        </div>
                      )}

                      {destination && (
                        <div>
                          ✓ Centro de {destination} / Traslado Aeroporto
                        </div>
                      )}

                      {servicePackageAvails?.map((service, index) => (
                        <div key={index}>
                          ✓ {service.servicePackage?.name || service.name}
                        </div>
                      ))}

                      {(!servicePackageAvails ||
                        servicePackageAvails.length === 0) &&
                        destination && <div>✓ {destination} - City Tour</div>}

                      {hotel.priority?.type && (
                        <div>✓ {hotel.priority.type}</div>
                      )}

                      {(packageInfo.end || checkOut) && (
                        <div>✓ {formatDate(packageInfo.end || checkOut)}</div>
                      )}
                    </S.PackageItemsList>
                  </S.PackageItemsSection>
                )}
              </S.ThreeSectionContainer>
            </S.HotelSection>
          )}
        </S.PackageContent>
      )}

      <Dialog
        open={modalOpen}
        onClose={handleCloseModal}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: "12px",
            maxHeight: "90vh",
            overflow: "hidden",
            background: "linear-gradient(145deg, #f8f9fa 0%, #ffffff 100%)",
          },
        }}
      >
        <DialogTitle style={{ padding: 0 }}>
          <S.ModalHeader>
            <div className="title-container">
              <span className="icon">✈️</span>
              <h3>Detalhes do Pacote</h3>
            </div>
            <div className="subtitle">{packageTitle}</div>
            <IconButton
              onClick={handleCloseModal}
              size="small"
              className="close-button"
            >
              <CloseIcon />
            </IconButton>
          </S.ModalHeader>
        </DialogTitle>
        <DialogContent
          style={{
            padding: 0,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <S.TabsSection>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              variant="fullWidth"
            >
              <Tab label="Informações" />
              <Tab label="Roteiro" />
              <Tab label="Serviços Incluídos" />
              <Tab label="Observações" />
            </Tabs>

            <TabPanel value={activeTab} index={0}>
              <S.TabContent>
                <h4>Informações Gerais</h4>

                <S.InfoGrid>
                  <S.InfoCard>
                    <div className="label">Destino</div>
                    <div className="value">
                      {destination},{" "}
                      {hotel.address?.city?.country?.name || countryCode}
                    </div>
                  </S.InfoCard>

                  <S.InfoCard>
                    <div className="label">Duração</div>
                    <div className="value">
                      {duration} dias / {nights} noites
                    </div>
                  </S.InfoCard>

                  <S.InfoCard>
                    <div className="label">Período</div>
                    <div className="value">
                      {formatDate(packageInfo.start || checkIn)} até{" "}
                      {formatDate(packageInfo.end || checkOut)}
                    </div>
                  </S.InfoCard>

                  <S.InfoCard>
                    <div className="label">Hotel</div>
                    <div className="value">
                      {hotel.name} {hotel.stars && `(${hotel.stars} ⭐)`}
                    </div>
                  </S.InfoCard>

                  <S.InfoCard>
                    <div className="label">Check-in / Check-out</div>
                    <div className="value">
                      {formatDate(checkIn)} 15:00h / {formatDate(checkOut)}{" "}
                      11:00h
                    </div>
                  </S.InfoCard>

                  <S.InfoCard>
                    <div className="label">Companhia Aérea</div>
                    <div className="value">{airline}</div>
                  </S.InfoCard>

                  <S.InfoCard>
                    <div className="label">Aeroportos</div>
                    <div className="value">
                      {originAirport} ⇄ {destinationAirport}
                    </div>
                  </S.InfoCard>

                  {hotel.priority && (
                    <S.InfoCard>
                      <div className="label">Recomendação</div>
                      <div className="value">{hotel.priority.type}</div>
                    </S.InfoCard>
                  )}
                </S.InfoGrid>

                <h5>Endereço do Hotel</h5>
                <p>{hotel.address?.address}</p>

                {hotelAvail?.provider && (
                  <>
                    <h5>Operadora</h5>
                    <p>{hotelAvail.provider}</p>
                  </>
                )}
              </S.TabContent>
            </TabPanel>

            <TabPanel value={activeTab} index={1}>
              <S.TabContent>
                <h4>Roteiro da Viagem</h4>

                <S.Timeline>
                  {packageInfo.roadMap && packageInfo.roadMap.length > 0 ? (
                    packageInfo.roadMap.map((day, index) => (
                      <S.TimelineItem key={index} day={day.sqDay}>
                        <h5>
                          {day.sqDay}º Dia - {day.name}
                        </h5>
                        {day.description && (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: day.description,
                            }}
                          />
                        )}
                      </S.TimelineItem>
                    ))
                  ) : (
                    <>
                      <S.TimelineItem day="1">
                        <h5>
                          1º Dia - {formatDate(packageInfo.start || checkIn)}
                        </h5>
                        <p>
                          ✈️ Saída do Aeroporto {originAirport} (
                          {firstFlight?.origin?.city?.name || "São Paulo"})
                        </p>
                        <p>
                          🛫 Voo {firstFlight?.number || "LA3912"} - {airline}
                        </p>
                        <p>
                          🛬 Chegada em {destination} - Aeroporto{" "}
                          {destinationAirport}
                        </p>
                        <p>🚐 Transfer aeroporto/hotel</p>
                        <p>🏨 Check-in no {hotel.name}</p>
                        <p>🌅 Tarde livre para descanso</p>
                      </S.TimelineItem>

                      {Array.from({ length: duration - 2 }, (_, i) => (
                        <S.TimelineItem key={i + 2} day={i + 2}>
                          <h5>{i + 2}º Dia</h5>
                          <p>🍳 Café da manhã no hotel</p>
                          <p>
                            🎯{" "}
                            {i === 0
                              ? `City Tour por ${destination}`
                              : "Dia livre para atividades opcionais"}
                          </p>
                          <p>🌙 Noite livre</p>
                        </S.TimelineItem>
                      ))}

                      <S.TimelineItem day={duration}>
                        <h5>
                          {duration}º Dia -{" "}
                          {formatDate(packageInfo.end || checkOut)}
                        </h5>
                        <p>🍳 Café da manhã no hotel</p>
                        <p>🏨 Check-out do hotel</p>
                        <p>🚐 Transfer hotel/aeroporto</p>
                        <p>
                          🛫 Voo {secondFlight?.number || "LA3913"} - {airline}
                        </p>
                        <p>🏠 Chegada ao Aeroporto {originAirport}</p>
                      </S.TimelineItem>
                    </>
                  )}
                </S.Timeline>
              </S.TabContent>
            </TabPanel>

            <TabPanel value={activeTab} index={2}>
              <S.TabContent>
                <h4>Serviços Incluídos e Exclusões</h4>

                <h5>✓ Serviços Inclusos</h5>
                <ul>
                  <li>
                    🛫 Passagem aérea {originAirport}/{destinationAirport}/
                    {originAirport} - {airline}
                  </li>
                  <li>
                    🏨 Hospedagem {nights} noites no {hotel.name} ({hotel.stars}{" "}
                    estrelas)
                  </li>
                  <li>
                    🍽️ Regime:{" "}
                    {roomGroups[0]?.rooms[selectedRoomIndex]?.boardType?.name ||
                      "Room Only"}
                  </li>
                  <li>🚐 Transfer aeroporto/hotel/aeroporto</li>
                  <li>👥 Assistência de viagem 24h</li>
                  <li>📋 Taxas de embarque</li>
                  {servicePackageAvails.map((service, index) => (
                    <li key={index}>🎁 {service.servicePackage?.name}</li>
                  ))}
                  {roomGroups[0]?.rooms[selectedRoomIndex]?.fares?.map(
                    (fare, index) =>
                      fare.type === "FARE" && (
                        <li key={index}>💳 Taxa de serviço incluída</li>
                      )
                  )}
                </ul>

                <h5>❌ Não Inclusos</h5>
                <ul
                  style={{
                    background: "rgba(255, 99, 99, 0.05)",
                    borderLeft: "3px solid #ff6363",
                  }}
                >
                  <li>🍽️ Refeições não mencionadas no regime</li>
                  <li>🍹 Bebidas alcoólicas e não alcoólicas</li>
                  <li>🎯 Passeios opcionais</li>
                  <li>💰 Despesas pessoais e extras</li>
                  <li>💵 Gorjetas</li>
                  <li>🌡️ Seguro viagem (recomendado)</li>
                  <li>📄 Documentos de viagem</li>
                  {roomGroups[0]?.rooms[selectedRoomIndex]?.fares?.map(
                    (fare, index) =>
                      fare.type === "TAX" && (
                        <li key={index}>💳 {fare.description}</li>
                      )
                  )}
                </ul>

                <h5>📦 Políticas de Bagagem</h5>
                <S.InfoGrid>
                  <S.InfoCard>
                    <div className="label">Bagagem de Mão</div>
                    <div className="value">Consulte políticas da {airline}</div>
                  </S.InfoCard>
                  <S.InfoCard>
                    <div className="label">Bagagem Despachada</div>
                    <div className="value">Consulte políticas da {airline}</div>
                  </S.InfoCard>
                  {firstFlight?.segments?.[0]?.baggage && (
                    <S.InfoCard>
                      <div className="label">Franquia Incluída</div>
                      <div className="value">
                        {firstFlight.segments[0].baggage.weight}kg -{" "}
                        {firstFlight.segments[0].baggage.type}
                      </div>
                    </S.InfoCard>
                  )}
                </S.InfoGrid>
              </S.TabContent>
            </TabPanel>

            <TabPanel value={activeTab} index={3}>
              <S.TabContent>
                <h4>Observações e Políticas Importantes</h4>

                {packageInfo.observation ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: packageInfo.observation,
                    }}
                  />
                ) : (
                  <>
                    <h5>📄 Documentação Necessária</h5>
                    <S.InfoGrid>
                      <S.InfoCard>
                        <div className="label">Passaporte</div>
                        <div className="value">Validade mínima de 6 meses</div>
                      </S.InfoCard>
                      <S.InfoCard>
                        <div className="label">Visto para {countryCode}</div>
                        <div className="value">
                          Não necessário (até 90 dias)
                        </div>
                      </S.InfoCard>
                      <S.InfoCard>
                        <div className="label">Menores de 18 anos</div>
                        <div className="value">
                          Autorização com firma reconhecida
                        </div>
                      </S.InfoCard>
                    </S.InfoGrid>

                    <h5>🏨 Informações do Hotel</h5>
                    <S.InfoGrid>
                      <S.InfoCard>
                        <div className="label">Check-in / Check-out</div>
                        <div className="value">15:00h / 11:00h</div>
                      </S.InfoCard>
                      <S.InfoCard>
                        <div className="label">Categoria</div>
                        <div className="value">{hotel.stars} estrelas</div>
                      </S.InfoCard>
                      {hotel.priority && (
                        <S.InfoCard>
                          <div className="label">Classificação</div>
                          <div className="value">{hotel.priority.type}</div>
                        </S.InfoCard>
                      )}
                    </S.InfoGrid>

                    <h5>🛫 Informações dos Voos</h5>
                    <ul>
                      <li>
                        🕓 Apresentar-se no aeroporto 3h antes (voos
                        internacionais)
                      </li>
                      <li>
                        💺 Confirmação de assento mediante disponibilidade
                      </li>
                      <li>📦 Consultar políticas de bagagem da {airline}</li>
                    </ul>

                    <h5>🚫 Políticas de Cancelamento</h5>
                    {roomGroups[0]?.rooms[selectedRoomIndex]
                      ?.cancellationPolicies ? (
                      <S.InfoGrid>
                        <S.InfoCard>
                          <div className="label">Reembolsável</div>
                          <div
                            className="value"
                            style={{
                              color: roomGroups[0].rooms[selectedRoomIndex]
                                .cancellationPolicies.refundable
                                ? "#27ae60"
                                : "#e74c3c",
                            }}
                          >
                            {roomGroups[0].rooms[selectedRoomIndex]
                              .cancellationPolicies.refundable
                              ? "✓ Sim"
                              : "❌ Não"}
                          </div>
                        </S.InfoCard>
                        <S.InfoCard>
                          <div className="label">Multa Imediata</div>
                          <div
                            className="value"
                            style={{
                              color: roomGroups[0].rooms[selectedRoomIndex]
                                .cancellationPolicies.immediateFine
                                ? "#e74c3c"
                                : "#27ae60",
                            }}
                          >
                            {roomGroups[0].rooms[selectedRoomIndex]
                              .cancellationPolicies.immediateFine
                              ? "⚠️ Sim"
                              : "✓ Não"}
                          </div>
                        </S.InfoCard>
                        {roomGroups[0].rooms[
                          selectedRoomIndex
                        ].cancellationPolicies.penalties?.map(
                          (penalty, index) => (
                            <S.InfoCard key={index}>
                              <div className="label">{penalty.name}</div>
                              <div className="value">
                                {penalty.percent
                                  ? `${
                                      penalty.percent
                                    }% a partir de${" "} ${formatDate(
                                      penalty.from
                                    )}`
                                  : "Não informado pelo fornecedor"}
                              </div>
                            </S.InfoCard>
                          )
                        )}
                      </S.InfoGrid>
                    ) : (
                      <p>
                        📄 Sujeito às políticas da operadora{" "}
                        {hotelAvail?.provider}
                      </p>
                    )}

                    <h5>⚠️ Observações Gerais</h5>
                    <ul>
                      <li>
                        📅 Pacote válido:{" "}
                        {formatDate(packageInfo.start || checkIn)} a{" "}
                        {formatDate(packageInfo.end || checkOut)}
                      </li>
                      <li>💰 Preços sujeitos a alterações sem aviso prévio</li>
                      <li>
                        ✓ Confirmação dos serviços sujeita à disponibilidade
                      </li>
                      <li>🌡️ Recomendamos fortemente seguro viagem</li>
                      {packageInfo.name && (
                        <li>🎁 Pacote especial: {packageInfo.name}</li>
                      )}
                    </ul>
                  </>
                )}
              </S.TabContent>
            </TabPanel>
          </S.TabsSection>
        </DialogContent>
      </Dialog>

      <Dialog
        open={hotelModalOpen}
        onClose={handleCloseHotelModal}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: "8px",
            maxHeight: "90vh",
            overflow: "hidden",
          },
        }}
      >
        <DialogTitle style={{ padding: 0 }}>
          <S.HotelModalHeader>
            <div className="title-container">
              <span className="icon">🏨</span>
              <h3>Detalhes do Hotel</h3>
            </div>
            <div className="subtitle">
              {hotel.name} - {hotel.address?.city?.name}
            </div>
            <IconButton
              onClick={handleCloseHotelModal}
              size="small"
              className="close-button"
            >
              <CloseIcon />
            </IconButton>
          </S.HotelModalHeader>
        </DialogTitle>
        <DialogContent style={{ padding: "20px" }}>
          <S.HotelModalContent>
            {(hotel.images?.length > 0 || hotel.name) && (
              <S.HotelModalLeft>
                <S.HotelModalLogo>
                  {hotel.images && hotel.images.length > 0 ? (
                    <img
                      src={
                        hotel.images[0].small ||
                        hotel.images[0].medium ||
                        hotel.images[0].large
                      }
                      alt={hotel.name}
                    />
                  ) : (
                    <div className="hotel-placeholder">
                      <span>
                        {hotel.name?.substring(0, 2).toUpperCase() || "HT"}
                      </span>
                      <small>HOTEL</small>
                    </div>
                  )}
                </S.HotelModalLogo>
              </S.HotelModalLeft>
            )}

            <S.HotelModalCenter>
              {hotel.name && (
                <S.HotelModalName>
                  {hotel.name}{" "}
                  {hotel.stars &&
                    [...Array(hotel.stars)].map((_, i) => "⭐").join("")}
                </S.HotelModalName>
              )}

              {(hotel.address?.address || hotel.address?.city?.name) && (
                <S.HotelModalAddress>
                  📍 {hotel.address?.address || hotel.address?.city?.name}
                </S.HotelModalAddress>
              )}

              {(hotel.highlight ||
                hotel.description ||
                hotel.address?.neighborhood) && (
                <S.HotelModalDescription>
                  <strong>Sobre o Hotel</strong>
                  <p>
                    {hotel.highlight ||
                      hotel.description ||
                      (hotel.address?.neighborhood &&
                        `Hotel localizado em ${hotel.address.neighborhood}, ${
                          hotel.address?.city?.name || ""
                        }.`)}
                  </p>
                </S.HotelModalDescription>
              )}

              {/* Room Conditions - Only show if there are rooms */}
              {roomGroups[0]?.rooms?.length > 0 && (
                <S.HotelModalConditions>
                  <div className="condition-title">Condições Disponíveis</div>
                  {roomGroups[0].rooms.map((room, index) => {
                    const roomWithPackagePrice =
                      room.cashPrice + packageData.packageWithoutRoomCashPrice;

                    const formattedPrice = roomWithPackagePrice.toLocaleString(
                      "pt-BR",
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    );

                    const pointsValue = getValuesByUser(roomWithPackagePrice);

                    return (
                      <S.HotelConditionItem
                        key={index}
                        className={
                          index === selectedRoomIndex ? "selected" : ""
                        }
                        onClick={() => handleRoomSelection(index)}
                      >
                        <div className="accomodation-container">
                          <input
                            type="radio"
                            name="condition"
                            checked={index === selectedRoomIndex}
                            onChange={() => handleRoomSelection(index)}
                          />
                          <div className="accomodation-title">
                            <span className="accommodation-type">
                              {room.roomType?.name}
                            </span>
                            <span className="accomodation-description">
                              {room.boardType?.name}
                            </span>
                          </div>
                        </div>
                        <span className="price">
                          {signed &&
                          !user?.guest &&
                          !user?.campaign?.disablePointActivity ? (
                            <span>
                              {pointsValue} {shortenCoinAlias}
                            </span>
                          ) : (
                            <span>R$ {formattedPrice}</span>
                          )}
                        </span>
                      </S.HotelConditionItem>
                    );
                  })}
                </S.HotelModalConditions>
              )}
            </S.HotelModalCenter>

            {/* Right Section - Only show if there's pricing info or images */}
            {(roomGroups[0]?.rooms?.length > 0 || hotel.images?.length > 0) && (
              <S.HotelModalRight>
                {roomGroups[0]?.rooms?.[selectedRoomIndex]?.fares?.length >
                  0 && (
                  <S.HotelModalPriceInfo>
                    {(() => {
                      const selectedRoom =
                        roomGroups[0].rooms[selectedRoomIndex];
                      const totalFare =
                        selectedRoom.cashPrice +
                        packageData.packageWithoutRoomCashPrice;

                      const taxAmount =
                        selectedRoom.fares.find((fare) => fare.type === "TAX")
                          ?.price?.amount || 0;

                      if (!totalFare) return null;

                      const showPoints =
                        signed &&
                        !user?.guest &&
                        !user?.campaign?.disablePointActivity;

                      if (showPoints) {
                        const pointsTotal = getValuesByUser(totalFare);
                        const pointsTax = getValuesByUser(taxAmount);
                        const pointsPerPerson = Math.ceil(
                          pointsTotal / (selectedRoom.names?.length || 1)
                        );

                        return (
                          <>
                            <div className="total-label">
                              Total:{" "}
                              <strong>
                                {pointsTotal} {shortenCoinAlias}
                              </strong>
                            </div>
                            {taxAmount > 0 && (
                              <div className="taxes-info">
                                Taxas incluídas: {pointsTax} {shortenCoinAlias}
                              </div>
                            )}
                            {selectedRoom.names?.length && (
                              <div className="per-person">
                                Por pessoa: {pointsPerPerson} {shortenCoinAlias}
                              </div>
                            )}
                          </>
                        );
                      } else {
                        const formattedTotal = totalFare.toLocaleString(
                          "pt-BR",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        );
                        const formattedTax = taxAmount.toLocaleString("pt-BR", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        });
                        const perPerson = (
                          totalFare / (selectedRoom.names?.length || 1)
                        ).toLocaleString("pt-BR", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        });

                        return (
                          <>
                            <div className="total-label">
                              Total: R$ <strong>{formattedTotal}</strong>
                            </div>
                            {taxAmount > 0 && (
                              <div className="taxes-info">
                                Taxas incluídas: R$ {formattedTax}
                              </div>
                            )}
                            {selectedRoom.names?.length && (
                              <div className="per-person">
                                Por pessoa: R$ {perPerson}
                              </div>
                            )}
                          </>
                        );
                      }
                    })()}
                  </S.HotelModalPriceInfo>
                )}

                {hotel.images?.length > 0 && (
                  <S.HotelModalPhotosButton>
                    📷 Fotos ({hotel.images.length})
                  </S.HotelModalPhotosButton>
                )}

                {hotel.images?.length > 1 && (
                  <S.HotelModalGallery>
                    <img
                      src={
                        hotel.images[1].medium ||
                        hotel.images[1].large ||
                        hotel.images[1].small
                      }
                      alt={`${hotel.name} - Foto 2`}
                    />
                  </S.HotelModalGallery>
                )}
              </S.HotelModalRight>
            )}
          </S.HotelModalContent>
        </DialogContent>
      </Dialog>
    </S.PackageCard>
  );
};

export default PackageSummaryCard;
